import styled from 'styled-components';
import { Inset } from 'syf-component-library/ui/spacing';
export const NoMembersFoundContainer = styled(Inset) `
  text-align: center;
`;
